<section class="sidenav">
  <section class="sidenav__weekly">
    <strong>Weekly plublications</strong>
    <app-weekly-chart
      [chartData]="chartData"
      [publicationType]="publicationType">
    </app-weekly-chart>
    <mat-radio-group class="sidenav__weekly__options"
      [(ngModel)]="publicationType">
      <mat-radio-button
      *ngFor="let type of chartType"
      [value]="type.value">{{type.name}}
    </mat-radio-button>
    </mat-radio-group>
  </section>
  <section class="sidenav__world">
    <strong>Countries Mentioned in Abstracts</strong>
    <app-articles-map (getLoading)="getLoading($event)"></app-articles-map>
    <button [disabled]="loading" mat-stroked-button (click)="openModal()">
      <mat-icon>fullscreen</mat-icon>
      Maximize</button>
  </section>
  <section class="sidenav__categories">
    <strong>CATEGORIES</strong>
    <mat-list>
      <mat-list-item *ngFor="let item of categories">
        <a (click)="getCategory(item)"
          [ngClass]="{'sidenav__categories--active': currentCategory === item.category}">
          <span>{{item.category}}</span>
          <span>{{item.total}}</span>
        </a>
        <mat-divider></mat-divider>
      </mat-list-item>
    </mat-list>
  </section>
  <section class="sidenav__countries">
    <strong>COUNTRIES LIST</strong>
    <mat-list>
      <mat-list-item *ngFor="let item of countries">
        <a (click)="getCountry(item)"
          [ngClass]="{'sidenav__categories--active': currentCategory === item.country}">
          <span>{{item.country}}</span>
          <span>{{item.total}}</span>
        </a>
        <mat-divider></mat-divider>
      </mat-list-item>
    </mat-list>
  </section>
</section>
